import { Component, OnInit } from '@angular/core';
import { AuthService } from '../core/services/auth.service';
import { NotificationService } from '../core/services/notification.service';
import { AppNotification } from '../core/models/notification.model';
import { User } from '../core/models/user.model';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss']
})
export class LayoutComponent implements OnInit {
  isSidebarCollapsed = false;
  isNotificationsOpen = false;
  isProfileMenuOpen = false;

  currentUser$: Observable<User | null>;
  notifications$: Observable<AppNotification[]>;
  unreadCount$: Observable<number>;

  activeToast: AppNotification | null = null;

  constructor(
    private authService: AuthService,
    private notificationService: NotificationService,
    private router: Router
  ) {
    this.currentUser$ = this.authService.currentUser$;
    this.notifications$ = this.notificationService.notifications$;
    this.unreadCount$ = this.notificationService.unreadCount$;

    this.notificationService.toast$.subscribe(toast => {
      if (toast) {
        this.activeToast = toast;
        setTimeout(() => {
          this.activeToast = null;
          this.notificationService.clearToast();
        }, 3000); // Hide after 3 seconds
      }
    });
  }

  ngOnInit(): void {}

  toggleSidebar() {
    this.isSidebarCollapsed = !this.isSidebarCollapsed;
  }

  toggleNotifications() {
    this.isNotificationsOpen = !this.isNotificationsOpen;
    if (this.isNotificationsOpen) {
      this.isProfileMenuOpen = false;
    }
  }

  toggleProfileMenu() {
    this.isProfileMenuOpen = !this.isProfileMenuOpen;
    if (this.isProfileMenuOpen) {
      this.isNotificationsOpen = false;
    }
  }

  markAsRead(id: string) {
    this.notificationService.markAsRead(id);
  }

  removeNotification(id: string, event: Event) {
    event.stopPropagation();
    this.notificationService.removeNotification(id);
  }

  logout() {
    this.authService.logout();
    this.router.navigate(['/login']);
  }
}
